import { CheckCircle2, Clock3, Pencil, Tag } from "lucide-react";
import { ChoiceButton } from "@/components/ChoiceButton";

// STEP 1 THEN STEP 2 (his order, 23 Oct): name each tag for what it IS, then open each one and place its numbers.
// "3 of 5 named" counts only tags a person named; "3 of 5 placed" counts tags whose numbers are all placed or passed.
export function TagStepBar({ named, placed, total, waiting = 0 }) {
  const Step = ({ testid, title, done, of, color, sub }) => (
    <div data-testid={testid} className="flex-1 min-w-[200px] rounded-xl border-[1.5px] border-slate-200 bg-white px-3 py-2">
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-[12px] font-bold text-slate-800">{title}</span>
        <span data-testid={`${testid}-count`} className="font-mono text-[11px] font-bold text-slate-600">{done} of {of}</span>
      </div>
      <div className="mt-1.5 h-1.5 rounded-full bg-slate-100 overflow-hidden">
        <div className={`h-full ${color} transition-[width] duration-500`} style={{ width: `${of ? (100 * done) / of : 0}%` }} />
      </div>
      {sub && <div data-testid={`${testid}-sub`} className="mt-1 text-[10px] text-amber-800">{sub}</div>}
    </div>
  );
  return (
    <div className="flex flex-wrap gap-2" data-testid="ai-tag-steps">
      <Step testid="ai-tag-step-named" title="Step 1 · Name the tags" done={named} of={total} color="bg-sky-600"
        sub={waiting ? `${waiting} name${waiting === 1 ? "" : "s"} waiting for a list admin's approval — you can carry on` : ""} />
      <Step testid="ai-tag-step-placed" title="Step 2 · Place the numbers" done={placed} of={total} color="bg-emerald-600" />
    </div>
  );
}

const Chip = ({ testid, tone, icon: Icon, children }) => (
  <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest ${tone}`}>
    <Icon className="w-3 h-3" />{children}
  </span>
);

// THE ONE-TAP NAME ON A TAG'S HEADER: the suggestion (our names list + our brands list), or pick another.
export function TagNameChoice({ gi, info, busy, onAccept, onPick }) {
  if (!info) return null;
  if (info.named) {
    return (
      <div className="w-full flex flex-wrap items-center gap-1.5" data-testid={`ai-tag-name-done-${gi}`}>
        <Chip testid={`ai-tag-name-named-${gi}`} tone="border-emerald-300 bg-emerald-50 text-emerald-800" icon={CheckCircle2}>named</Chip>
        {info.waiting_for_approval && (
          <Chip testid={`ai-tag-name-waiting-${gi}`} tone="border-amber-300 bg-amber-50 text-amber-800" icon={Clock3}>name waiting for approval</Chip>
        )}
        {info.brand && <span data-testid={`ai-tag-brand-${gi}`} className="text-[11px] text-slate-600">brand <b>{info.brand}</b></span>}
        {info.by && <span className="text-[10px] text-slate-400">by {String(info.by).split("@")[0]}</span>}
        <ChoiceButton data-testid={`ai-tag-name-change-${gi}`} disabled={busy} onClick={onPick} className="h-8 min-h-8">
          <Pencil className="w-3 h-3 mr-1" />Change the name
        </ChoiceButton>
      </div>
    );
  }
  const s = info.suggested;
  return (
    <div className="w-full flex flex-wrap items-center gap-1.5" data-testid={`ai-tag-name-ask-${gi}`}>
      <Chip testid={`ai-tag-name-needed-${gi}`} tone="border-amber-300 bg-amber-50 text-amber-800" icon={Tag}>needs a name</Chip>
      {s && (
        <ChoiceButton tone="go" data-testid={`ai-tag-name-accept-${gi}`} disabled={busy} onClick={onAccept}>
          <CheckCircle2 className="w-3.5 h-3.5 mr-1" />{s.name}{s.brand ? ` · brand ${s.brand}` : ""}
        </ChoiceButton>
      )}
      <ChoiceButton data-testid={`ai-tag-name-pick-${gi}`} disabled={busy} onClick={onPick}>
        {s ? "Pick another name" : "Pick a name"}
      </ChoiceButton>
    </div>
  );
}
